import {
  ICheckout, ICheckoutItem, ICheckoutMeta, CheckoutMeta, CheckoutItem
} from './index'
import {IOrderData, IRequestItem} from '../index'

export class Checkout implements ICheckout {
  readonly line_items: ICheckoutItem[]
  readonly metadata?: ICheckoutMeta

  constructor(data: IOrderData) {
    this.metadata = new CheckoutMeta({
      order: data.token,
      customer: data.customer.id
    })
    // FORM CHECKOUT ITEMS LIST
    let travel = data.request_travel
    let promo = data.promo_code
    let services: IRequestItem[] = [
      ...(data.request_service || []),
      ...(travel ? [travel] : []),
      ...(promo ? [promo] : [])
    ].filter(s => !!s?.price);
    const product = data.stripe_product;
    const price = data.stripe_price;
    if (data.solution_name && product && price) {
      // it's a solution order
      services.push({
        stripe_price: price,
        stripe_product: product
      });
    }
    this.line_items = services.map((item: IRequestItem) => new CheckoutItem(item));
  }
}
